import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import LandingHeader from "../components/LandingHeader";
import LandingFooter from "../components/LandingFooter";
import DemoForm from "../components/forms/Form";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>30 Day Marketing Challenge - courtesy of Elm Street</title>
        <meta
          name="description"
          content="Simple steps to elevate your marketing in less than 1-month. Are you ready to change your Marketing for the better? Get started with this FREE guide."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/30day-marketing-challenge" />
        <meta property="og:title" content="30 Day Marketing Challenge - courtesy of Elm Street" />
        <meta
          property="og:description"
          content="Simple steps to elevate your marketing in less than 1-month. Are you ready to change your Marketing for the better? Get started with this FREE guide."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />

      <LandingHeader />

      <div
        style={{
          backgroundImage: "url('esbg3.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "35px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h2" component="h1" style={{ color: "#ffffff" }}>
                  <span style={{ color: "#f69c26" }}>30 Day</span> marketing
                  <br />
                  challenge
                </Typography>
                <br />
                <span style={{ color: "#ffffff" }}>
                  "It takes 30-days for a change in behavior to become a habit, and six months for a habit to become the
                  automatic way a person does things. If you haven't changed in 30-days, it's not happening." - Mark
                  Goulston
                  <br />
                  <br />
                  <strong style={{ color: "#f69c26" }}>
                    Simple steps to elevate your
                    <br />
                    marketing in less than 1-month.
                  </strong>
                  <br />
                  Are you ready to change your Marketing for the better? Get started with this FREE guide.
                </span>
              </Grid>
              <Grid item md={6} sm={12} style={{ marginBottom: "-6px" }}>
                <div>
                  <Image
                    src="/30daycover.jpg"
                    width="800px"
                    height="618px"
                    alt="Elm Street - 30 Day Marketing Challenge"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <Container maxWidth="lg" style={{ textAlign: "left" }}>
        <div style={{ marginTop: "68px", marginBottom: "68px" }}>
          <Grid container spacing={8} justifyContent="center">
            <Grid item md={8}>
            <DemoForm
              buttonText="Download Now"
              successMsg={<div style={{textAlign:"center"}}><strong>Thank you for your interest!</strong><br/><br/><Button variant="contained" color="secondary" href="/assets/30daymarketingchallenge.pdf">Download the PDF</Button></div>}
              formName="es2_marketing_challenge" listId="148009"
              fieldList={["first_name", "last_name", "email", "phone", "roll"]}
            />
            </Grid>
          </Grid>
        </div>
      </Container>

      <LandingFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
